import { Injectable } from '@angular/core';
import { AppAPIConfig } from './app-api-config';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { SalaryPartnerModel } from '../account-report/salary/salary-partner-model';
import { EmployeeLeaveSummaryModel } from '../hr-report/emp-leave-summary/emp-leave-summary.model';
import { ArticleStipend } from '../account-report/stipend/stipend.module';
import { PenaltySummaryModel } from '../hr-report/penalty-summary/penalty-summary.model';
import { IndependenceModel } from '../analytic-report/declaration.model';
import { UserShortModel } from '../models/user-short.model';
import { ClientShortModel } from '../models/client-short.model';
import { BudgetReportModel } from '../analytic-report/budget/budget.model';
import { DocumentModel } from '../document-management-details/document-management/document-management.model';
import { Subject, Observable } from 'rxjs';
import { ExitFormModel } from '../user-details/exit-form/exit-form.model';

@Injectable({
  providedIn: 'root',
})
export class MasterDataService {
  appApi = new AppAPIConfig();
  httpOptions = {};
  httpOptionsForDelete: any;
  httpOptionsForExportToExcel = {};
  httpOptionsForUpload = {};

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };

    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };

    this.httpOptionsForUpload = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    };
  }

  refreshHttpOptions() {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };
    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };

    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };
  }

  getAllClientListForDecleration() {
    return this.http.get(this.appApi.getAllActiveClientList, this.httpOptions);
  }

  getCurrentAndLastfinancialYear() {
    return this.http.get(this.appApi.getCurrentAndLastfinancialYear, this.httpOptions);
  }

  saveIndependenceDecleration(data) {
    console.log(data);
    return this.http.post<any>(
      this.appApi.declerationApi,
      data,
      this.httpOptions
    );
  }

  getIndependenceDeclerationMail(id) {
    return this.http.get(
      this.appApi.getIndependenceDeclerationMailAPI + '/' + id,
      this.httpOptions
    );
  }

  getClientDetails(id) {
    return this.http.get(
      this.appApi.getClientsAPI + '/' + id,
      this.httpOptions
    );
  }
  getPendingDecleration(id) {
    return this.http.get(
      this.appApi.declerationPendingApi + '/' + id,
      this.httpOptions
    );
  }

  getDecleration(id) {
    return this.http.get(
      this.appApi.declerationApi + '/' + id,
      this.httpOptions
    );
  }

  getManDaysInBudgetClientDetails(fyId, userId) {
    return this.http.get<any>(
      this.appApi.budgetManDaysAPI + '/' + fyId + '/' + userId,
      this.httpOptions
    );
  }

  // getUserMenus() {
  //   return this.http.get(this.appApi.userMenuAPI, this.httpOptions);
  // }

  getUserMenus(roleId, serviceVerticalId, userId) {
    const params: any = {};
    if (userId != null) {
      params.userId = userId;
    }

    return this.http.get<any>(
      `${this.appApi.userMenuAPI}/${roleId}/${serviceVerticalId}`,
      { ...this.httpOptions, params }
    );
  }

  getAllMenus() {
    return this.http.get<any>(this.appApi.allMenusAPI, this.httpOptions);
  }

  saveAccessControl(body) {
    return this.http.post<any>(
      this.appApi.accessControlAPI,
      body,
      this.httpOptions
    );
  }

  getUsersByRoleAndServiceVertical(roleId, serviceVerticalId) {
  const params: any = {
    role: roleId,
    serviceVertical: serviceVerticalId ?? ''
  };

  return this.http.get<any>(
    this.appApi.userByRoleAndServiceVerticalAPI,
    { ...this.httpOptions, params }
  );
}


  getFolderList() {
    return this.http.get<DocumentModel>(this.appApi.folderAPI, this.httpOptions);
  }

  addFolder(body) {
    return this.http.post<DocumentModel>(
      this.appApi.folderAPI,
      body,
      this.httpOptions
    );
  }

  updateFolder(body) {
    return this.http.put<DocumentModel>(
      this.appApi.folderAPI,
      body,
      this.httpOptions
    );
  }

  deleteFolder(id) {
    return this.http.delete<DocumentModel>(
      this.appApi.folderAPI + '/' + id,
      this.httpOptions
    );
  }

  getMainFolderDocuments(folderId) {
    return this.http.get<any>(this.appApi.getFolderDocumentsAPI + '/' + folderId, this.httpOptions)
  }

  addDocument(folderId, body, downloadCheck) {
    console.log('body', body);
    console.log('file body', body.get('file'));

    var uploadHttpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    }
    return this.http.post<any>(this.appApi.singleDocumentAPI + '/' + folderId + '/' + downloadCheck, body, uploadHttpOptions);
  }

  addDocumentUrl(folderId, formData) {
    return this.http.post<any>(this.appApi.singleDocumentUrlAPI + '/' + folderId, formData, this.httpOptionsForUpload);
  }

  updateDocument(documentId, body, isDownloadCheck) {
    var uploadHttpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    }
    return this.http.put<any>(this.appApi.singleDocumentAPI + '/' + documentId + '/' + isDownloadCheck, body, uploadHttpOptions);

  }

  updateViewOnlyDocument(documentId, body, isDownloadCheck) {
    var uploadHttpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    }
    return this.http.put<any>(this.appApi.singleViewOnlyDocumentAPI + '/' + documentId + '/' + isDownloadCheck, body, uploadHttpOptions);

  }

  deleteBucketDocument(documentId) { }

  deleteDocument(documentId) {
    return this.http.delete<any>(this.appApi.singleDocumentAPI + '/' + documentId, this.httpOptions);
  }

  deleteDocumentUrl(documentId) {
    return this.http.delete<any>(this.appApi.deleteDocumentUrlAPI + '/' + documentId, this.httpOptions);
  }

  getUserProfileByIdForDecleration(id) {
    return this.http.get(this.appApi.profileAPI + '/' + id, this.httpOptions);
  }

  getUserProfile() {
    return this.http.get(
      this.appApi.profileAPI + '/' + localStorage.getItem('userid'),
      this.httpOptions
    );
  }

  getUserProfileById(id, token) {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: token,
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(this.appApi.profileAPI + '/' + id, this.httpOptions);
  }

  getUserByProfile(id) {
    return this.http.get<UserShortModel[]>(
      this.appApi.userByProfile + '/' + id,
      this.httpOptions
    );
  }

  usersByReportingPartner(id) {
    return this.http.get<UserShortModel[]>(
      this.appApi.userByReportingPartnerAPI + '?partnerId=' + id,
      this.httpOptions
    );
  }

  // Assignments
  getAssignments() {
    return this.http.get(this.appApi.assignmentAPI, this.httpOptions);
  }

  saveAssignment(body) {
    console.log(body);
    return this.http.post<any>(
      this.appApi.assignmentAPI,
      body,
      this.httpOptions
    );
  }

  updateAssignment(body) {
    return this.http.put<any>(
      this.appApi.assignmentAPI,
      body,
      this.httpOptions
    );
  }

  deleteAssignment(body) {
    this.httpOptionsForDelete.body = body;
    return this.http.delete<any>(
      this.appApi.assignmentAPI,
      this.httpOptionsForDelete
    );
  }

  // Tasks
  getTasks() {
    return this.http.get(this.appApi.taskAPI, this.httpOptions);
  }

  saveTask(body) {
    console.log(body);
    return this.http.post<any>(this.appApi.taskAPI, body, this.httpOptions);
  }

  viewTask(id) {
    return this.http.get(this.appApi.taskAPI + '/' + id, this.httpOptions);
  }

  updateTask(body) {
    console.log(body);
    return this.http.put<any>(this.appApi.taskAPI, body, this.httpOptions);
  }

  deleteTask(body) {
    this.httpOptionsForDelete.body = body;
    return this.http.delete<any>(
      this.appApi.taskAPI,
      this.httpOptionsForDelete
    );
  }

  // Branch
  getBranch() {
    return this.http.get(this.appApi.branchAPI, this.httpOptions);
  }

  // exportCommitmentLetter(userId) {
  //   return this.http.get(this.appApi.getCommitmentLetterForArticleAPI + '?userId=' + userId, this.httpOptions);
  // }
    exportCommitmentLetter(userId) {
  const options = {
    ...this.httpOptions,
    responseType: 'blob' as 'json'
  };

  return this.http.get(
    this.appApi.getCommitmentLetterForArticleAPI + '?userId=' + userId,
    options
  );
}

  // exportContractLetter(userId) {
  //   return this.http.get(this.appApi.getContractLetterForEmployeeAPI + '?userId=' + userId, this.httpOptions);
  // }
  exportContractLetter(userId) {
  const options = {
    ...this.httpOptions,
    responseType: 'blob' as 'json'
  };

  return this.http.get(
    this.appApi.getContractLetterForEmployeeAPI + '?userId=' + userId,
    options
  );
}

  // getDocumentUploadType(userType) {
  //   return this.http.get(
  //     this.appApi.documentUploadAPI + '/' + userType,
  //     this.httpOptions
  //   );
  // }

  getDocumentUploadList(userId) {
    return this.http.get(this.appApi.documentUploadListAPI + '/' + userId, this.httpOptions)
  }

  saveBranch(body) {
    console.log('body', body);
    return this.http.post<any>(this.appApi.branchAPI, body, this.httpOptions);
  }

  viewBranch(id) {
    return this.http.get(this.appApi.branchAPI + '/' + id, this.httpOptions);
  }

  updateBranch(body) {
    console.log('body', body);
    return this.http.put<any>(this.appApi.branchAPI, body, this.httpOptions);
  }

  deleteBranch(id) {
    return this.http.delete<any>(
      this.appApi.branchAPI + '/' + id,
      this.httpOptions
    );
  }

  // Financial Year
  getFinancialYear() {
    return this.http.get(this.appApi.financialYearAPI, this.httpOptions);
  }

  getBudgetExistForAssignent(clientId, fyId, assignmentId) {
    return this.http.get(this.appApi.clientBudgetForYearAPI + '/' + clientId + '/' + fyId + '/' + assignmentId, this.httpOptions);
  }

  saveFinancialYear(body) {
    return this.http.post<any>(
      this.appApi.financialYearAPI,
      body,
      this.httpOptions
    );
  }

  viewFinancialYear(id) {
    return this.http.get(
      this.appApi.financialYearAPI + '/' + id,
      this.httpOptions
    );
  }

  updateFinancialYear(body) {
    return this.http.put<any>(
      this.appApi.financialYearAPI,
      body,
      this.httpOptions
    );
  }

  deleteFinancialYear(id) {
    return this.http.delete<any>(
      this.appApi.financialYearAPI + '/' + id,
      this.httpOptions
    );
  }

  //Service vertical
  getServiceVerticalList() {
    return this.http.get(this.appApi.serviceVerticalAPI, this.httpOptions);
  }

  saveServiceVertical(body) {
    return this.http.post<any>(this.appApi.serviceVerticalAPI, body, this.httpOptions);
  }

  viewServiceVertical(id) {
    return this.http.get(this.appApi.serviceVerticalAPI + '/' + id, this.httpOptions);
  }

  updateServiceVertical(body) {
    return this.http.put<any>(this.appApi.serviceVerticalAPI, body, this.httpOptions);
  }

  deleteServiceVertical(id) {
    return this.http.delete<any>(
      this.appApi.serviceVerticalAPI + '/' + id,
      this.httpOptions
    );
  }

  // Roles
  getRoles() {
    return this.http.get(this.appApi.roleAPI, this.httpOptions);
  }

  saveRole(body) {
    return this.http.post<any>(this.appApi.roleAPI, body, this.httpOptions);
  }

  viewRole(id) {
    return this.http.get(this.appApi.roleAPI + '/' + id, this.httpOptions);
  }

  updateRole(body) {
    return this.http.put<any>(this.appApi.roleAPI, body, this.httpOptions);
  }

  deleteRole(id) {
    return this.http.delete<any>(
      this.appApi.roleAPI + '/' + id,
      this.httpOptions
    );
  }

  // designationAPI
  getDesignations() {
    return this.http.get(this.appApi.designationAPI, this.httpOptions);
  }

  saveDesignation(body) {
    return this.http.post<any>(
      this.appApi.designationAPI,
      body,
      this.httpOptions
    );
  }

  viewDesignation(id) {
    return this.http.get(
      this.appApi.designationAPI + '/' + id,
      this.httpOptions
    );
  }

  updateDesignation(body) {
    return this.http.put<any>(
      this.appApi.designationAPI,
      body,
      this.httpOptions
    );
  }

  deleteDesignation(id) {
    return this.http.delete<any>(
      this.appApi.designationAPI + '/' + id,
      this.httpOptions
    );
  }

  // Locations
  getLocations() {
    return this.http.get(this.appApi.locationAPI, this.httpOptions);
  }

  saveLocation(body) {
    return this.http.post<any>(this.appApi.locationAPI, body, this.httpOptions);
  }

  viewLocation(id) {
    return this.http.get(this.appApi.locationAPI + '/' + id, this.httpOptions);
  }

  updateLocation(body) {
    return this.http.put<any>(this.appApi.locationAPI, body, this.httpOptions);
  }

  deleteLocation(id) {
    return this.http.delete<any>(
      this.appApi.locationAPI + '/' + id,
      this.httpOptions
    );
  }

  // Partner
  getPartners() {
    return this.http.get(this.appApi.userPartnerAPI, this.httpOptions);
  }

  // Lookup
  getSectors() {
    return this.http.get(this.appApi.sectorAPI, this.httpOptions);
  }

  getEdiaryStatus() {
    return this.http.get(this.appApi.ediaryStatusAPI, this.httpOptions);
  }

  getLegalStatus() {
    return this.http.get(this.appApi.legalStatusAPI, this.httpOptions);
  }

  getStates() {
    return this.http.get(this.appApi.stateAPI, this.httpOptions);
  }

  getCities(id) {
    return this.http.get(this.appApi.cityAPI + '/' + id, this.httpOptions);
  }

  getPostcode(id) {
    return this.http.get(this.appApi.postcodeAPI + '/' + id, this.httpOptions);
  }

  // Checklist
  getCheckList() {
    return this.http.get(this.appApi.checklistAPI, this.httpOptions);
  }

  // Clients
  getClientLookups() {
    return this.http.get(this.appApi.clientAPI + '/lookups', this.httpOptions);
  }

  getClients(page, limit) {
    return this.http.get(
      this.appApi.clientAPI + '?page=' + page + '&limit=' + limit,
      this.httpOptions
    );
  }

  getClientByName(name) {
    return this.http.get(
      this.appApi.clientAPI + '/name?name=' + name,
      this.httpOptions
    );
  }

  deleteClient(id) {
    return this.http.delete<any>(
      this.appApi.clientAPI + '/' + id,
      this.httpOptions
    );
  }

  saveClient(body) {
    return this.http.post<any>(this.appApi.clientAPI, body, this.httpOptions);
  }

  viewClient(id) {
    return this.http.get(this.appApi.clientAPI + '/' + id, this.httpOptions);
  }

  updateClient(body) {
    return this.http.put<any>(this.appApi.clientAPI, body, this.httpOptions);
  }

  //
  getCertificationList() {
    return this.http.get(this.appApi.certificationAPI, this.httpOptions);
  }
  getClosingDatesByFinancialYear(id) {
    return this.http.get(
      this.appApi.closingDateAPI + '/' + id,
      this.httpOptions
    );
  }

  getSalaryReport(
    branchId,
    closingDateId,
    profileStatus,
    designationId,
    userId
  ) {
    return this.http.get<SalaryPartnerModel[]>(
      this.appApi.salaryReportAPI +
      '?branchId=' +
      branchId +
      '&closingDateId=' +
      closingDateId +
      '&profileStatus=' +
      profileStatus +
      '&designationId=' +
      designationId +
      '&userId=' +
      userId,
      this.httpOptions
    );
  }

  // getSalaryReportExportToExcel(branchId, closingDateId, profileStatus, designationId, userId) {
  //   return this.http.get<SalaryPartnerModel[]>(this.appApi.salaryReportExportToExcelAPI + '?branchId=' + branchId + '&closingDateId=' + closingDateId + '&profileStatus=' + profileStatus + '&designationId=' + designationId + '&userId=' + userId, this.httpOptionsForExportToExcel
  //   );
  // }

  getSalaryReportExportToExcel(branchId, closingDateId, profileStatus, designationId, userId) {
    return this.http.get<SalaryPartnerModel[]>(this.appApi.salaryReportExportToExcelAPI + '?branchId=' + branchId + '&closingDateId=' + closingDateId + '&profileStatus=' + profileStatus + '&designationId=' + designationId + '&userId=' + userId, this.httpOptionsForExportToExcel
    );
  }

  // http://localhost:8080/excel-export/employee/salary/excel?branchId=3&closingDateId=102&profileStatus=1&designationId=8,3,13,2,10,9,6,7,5,1,11,4&userId=0

  getStipendReport(branchId, closingDateId, profileStatus, userId) {
    return this.http.get<ArticleStipend[]>(
      this.appApi.stipendReportAPI +
      '?branchId=' +
      branchId +
      '&closingDateId=' +
      closingDateId +
      '&profileStatus=' +
      profileStatus +
      '&userId=' +
      userId,
      this.httpOptions
    );
  }

  getStipendReportExportToExcel(branchId, closingDateId, profileStatus, userId) {
    return this.http.get<ArticleStipend[]>(
      this.appApi.stipendReportExportToExcelAPI +
      '?branchId=' +
      branchId +
      '&closingDateId=' +
      closingDateId +
      '&profileStatus=' +
      profileStatus +
      '&userId=' +
      userId,
      this.httpOptionsForExportToExcel
    );
  }

  //Leave Summary
  getLeaveSummary(fyId, userId) {
    return this.http.get<EmployeeLeaveSummaryModel>(
      this.appApi.employeeLeaveSummaryAPI +
      '?fyId=' +
      fyId +
      '&userId=' +
      userId,
      this.httpOptions
    );
  }

  employeeLeaveReportExportToExcel(fyId, userId) {
    return this.http.get<EmployeeLeaveSummaryModel[]>(
      this.appApi.leaveSummaryExportToExcelAPI +
      '?fy=' +
      fyId +
      '&userId=' +
      userId,
      this.httpOptionsForExportToExcel
    );
  }

  //Penalty Summary
  getPanaltySummary(branchId, roleId, closingDateId, userId) {
    return this.http.get<PenaltySummaryModel[]>(
      this.appApi.penaltySummaryAPI +
      '?branchId=' +
      branchId +
      '&role=' +
      roleId +
      '&closingDateId=' +
      closingDateId +
      '&userId=' +
      userId,
      this.httpOptions
    );
  }

  getPenaltySummaryReportExportToExcel(branchId, roleId, closingDateId, userId) {
    return this.http.get<PenaltySummaryModel[]>(
      this.appApi.penaltySummaryExportToExcelAPI +
      '?branchId=' +
      branchId +
      '&role=' +
      roleId +
      '&closingDateId=' +
      closingDateId +
      '&userId=' +
      userId,
      this.httpOptionsForExportToExcel
    );
  }

  //Annual Independence Report
  getAnnualIndependence(fyId, employeeId, status) {
    return this.http.get<IndependenceModel>(
      this.appApi.annualIndependenceAPI +
      '?fyId=' +
      fyId +
      '&status=' +
      status +
      '&userId=' +
      employeeId,
      this.httpOptions
    );
  }

  getAnnualIndependenceExcel(fyId, employeeId, status) {
    return this.http.get<IndependenceModel>(
      this.appApi.annualIndependenceExcelAPI +
      '?fyId=' +
      fyId +
      '&status=' +
      status +
      '&userId=' +
      employeeId,
      this.httpOptionsForExportToExcel
    );
  }

  getClientIndependence(clientId, employeeId, status) {
    return this.http.get<IndependenceModel>(
      this.appApi.clientIndependenceAPI +
      '?clientId=' +
      clientId +
      '&status=' +
      status +
      '&userId=' +
      employeeId,
      this.httpOptions
    );
  }

  getNewClientIndependenceExcel(clientId, employeeId, status) {
    return this.http.get<IndependenceModel>(
      this.appApi.clientIndependenceExcelAPI +
      '?clientId=' +
      clientId +
      '&status=' +
      status +
      '&userId=' +
      employeeId,
      this.httpOptionsForExportToExcel
    );
  }

  getEmployeeIndependence(employeeId, status) {
    return this.http.get<IndependenceModel>(
      this.appApi.employeeIndependenceAPI +
      '?status=' +
      status +
      '&userId=' +
      employeeId,
      this.httpOptions
    );
  }

  getEmployeeJoiningDeclarationExcel(employeeId, status) {
    return this.http.get<IndependenceModel>(
      this.appApi.employeeJoiningDeclarationExcelAPI +
      '?status=' +
      status +
      '&userId=' +
      employeeId,
      this.httpOptionsForExportToExcel
    );
  }

  getAllClientIndependence(fyId, employeeId, status) {
    return this.http.get<IndependenceModel>(
      this.appApi.allClientIndependenceAPI +
      '?fyId=' +
      fyId +
      '&status=' +
      status +
      '&userId=' +
      employeeId,
      this.httpOptions
    );
  }

  getAllClientIndependenceExcel(fyId, employeeId, status) {
    return this.http.get<IndependenceModel>(
      this.appApi.allClientIndependenceExcelAPI +
      '?fyId=' +
      fyId +
      '&status=' +
      status +
      '&userId=' +
      employeeId,
      this.httpOptionsForExportToExcel
    );
  }

  getDpdpIndependence(fyId, employeeId, status) {
    return this.http.get<IndependenceModel>(
      this.appApi.dpdpIndependenceAPI +
      '?fyId=' +
      fyId +
      '&status=' +
      status +
      '&userId=' +
      employeeId,
      this.httpOptions
    );
  }

  getClientsForEmployee(userId) {
    return this.http.get<ClientShortModel[]>(
      this.appApi.clientEmployeeAPI + '?userId=' + userId,
      this.httpOptions
    );
  }
  getBudgetReport(fyId, userId) {
    return this.http.get<BudgetReportModel>(
      this.appApi.budgetReportAPI + '/' + userId + '/' + fyId,
      this.httpOptions
    );
  }
  getOldBudgetReportExcelToExport(fyId, userId) {
    return this.http.get<BudgetReportModel>(
      this.appApi.budgetReportExcelToExportOldAPI + '/' + userId + '/' + fyId,
      this.httpOptionsForExportToExcel
    );
  }

  getNewBudgetReportExcelToExport(fyId, userId) {
    return this.http.get<BudgetReportModel>(
      this.appApi.budgetReportExcelToExportNewAPI + '/' + userId + '/' + fyId,
      this.httpOptionsForExportToExcel
    );
  }

  getApprovalPenalty(userId, closingDateId) {
    return this.http.get(
      this.appApi.approvalPenaltyDetailAPI + '/' + userId + '/' + closingDateId,
      this.httpOptions
    );
  }

  getApprovalPenaltyExportToExcel(userId, closingDateId) {
    return this.http.get(
      this.appApi.approvalPenaltyExcelToExportAPI + '/' + userId + '/' + closingDateId,
      this.httpOptionsForExportToExcel
    );
  }

  getSubmissionPenalty(userId, closingDateId) {
    return this.http.get(
      this.appApi.submissionPenaltyDetailAPI +
      '/' +
      userId +
      '/' +
      closingDateId,
      this.httpOptions
    );
  }

  getSubmissionPenaltyExportToExcel(userId, closingDateId) {
    return this.http.get(
      this.appApi.submissionPenaltyExcelToExportAPI +
      '/' +
      userId +
      '/' +
      closingDateId,
      this.httpOptionsForExportToExcel
    );
  }

  getLateLeaveApplicationPenalty(userId, closingDateId) {
    return this.http.get(
      this.appApi.lateLeaveApplicationPenaltyDetailAPI +
      '/' +
      userId +
      '/' +
      closingDateId,
      this.httpOptions
    );
  }

  getLateLeaveApplicationExportToExcelPenalty(userId, closingDateId) {
    return this.http.get(
      this.appApi.lateLeaveApplicationPenaltyExcelToExportAPI +
      '/' +
      userId +
      '/' +
      closingDateId,
      this.httpOptionsForExportToExcel
    );
  }

  getLateLeaveApprovalPenalty(userId, closingDateId) {
    return this.http.get(
      this.appApi.lateLeaveApprovalPenaltyDetailAPI +
      '/' +
      userId +
      '/' +
      closingDateId,
      this.httpOptions
    );
  }

  getLateLeaveApprovalExportToExcelPenalty(userId, closingDateId) {
    return this.http.get(
      this.appApi.lateLeaveApprovalPenaltyExcelToExportAPI +
      '/' +
      userId +
      '/' +
      closingDateId,
      this.httpOptionsForExportToExcel
    );
  }

  getUserPartnersOfBranch(branchId) {
    return this.http.get(
      this.appApi.userPartnerOfBranchAPI + '?branchId=' + branchId,
      this.httpOptions
    );
  }

  getUsersOfPartner(partnerId) {
    return this.http.get(
      this.appApi.userOfPartnerAPI + '/' + partnerId,
      this.httpOptions
    );
  }

  getArticlesByReportingPartner(partnerId) {
    return this.http.get(
      this.appApi.articlesByReportingPartner + '?partnerId=' + partnerId,
      this.httpOptions
    );
  }


  getAnnualStipendReport(fyId, userId, partnerId, fromClosingDate, toClosingDate) {
    return this.http.get(
      this.appApi.multiplePartnerAnnualStipend + '/' + fyId + '?userId=' + userId + '&partnerId=' + partnerId + '&fromClosingDate=' + fromClosingDate + '&toClosingDate=' + toClosingDate,
      this.httpOptions
    );
  }

  getOneSixthReport(UserId, date) {
    return this.http.get(
      this.appApi.oneSixthReportAPI + '/' + UserId + '/' + date,
      this.httpOptions
    );
  }

  getOneSixthReportExcel(UserId, date) {
    return this.http.get(
      this.appApi.oneSixthReportExcelAPI + '/' + UserId + '/' + date,
      this.httpOptionsForExportToExcel
    );
  }

  getEmpanelmentRole() {
    return this.http.get(this.appApi.empanelmentRoleAPI, this.httpOptions);
  }

  getEmpanelmentRoleReport(branchId, empanelmentRoleId, currentDate, serviceVerticalId) {
    return this.http.get(
      this.appApi.empanelmentReportAPI +
      '?branchId=' +
      branchId +
      '&role=' +
      empanelmentRoleId +
      '&currDate=' +
      currentDate +
      '&serviceVertical=' +
      serviceVerticalId,
      this.httpOptions
    );
  }

  getChangePassword(data) {
    return this.http.put<any>(
      this.appApi.changePasswordAPI + '/' + data,
      {},
      this.httpOptions
    );
  }

  getForgotPassword(email) {
    return this.http.put<any>(
      this.appApi.forgotPasswordAPI + '?email=' + email,
      {}
    );
  }

  getMonthlyConveyanceReport(closingDateId, roleId, branchId, status) {
    return this.http.get<any>(
      this.appApi.monthlyConveyanceReportAPI +
      '?closingId=' +
      closingDateId +
      '&role=' +
      roleId +
      '&branch=' +
      branchId +
      '&status=' +
      status,
      this.httpOptions
    );
  }

  getMonthlyConveyanceDetailReport(closingDateId, roleId, branchId, status) {
    return this.http.get<any>(
      this.appApi.monthlyConveyanceDetailReportAPI +
      '?closingId=' +
      closingDateId +
      '&role=' +
      roleId +
      '&branch=' +
      branchId +
      '&status=' +
      status,
      this.httpOptions
    );
  }

  getMonthlyConveyanceReportExcel(closingDateId, roleId, branchId, status) {
    return this.http.get<any>(
      this.appApi.monthlyConveyanceDetailReportExportToExcelAPI +
      '?closingId=' +
      closingDateId +
      '&role=' +
      roleId +
      '&branch=' +
      branchId +
      '&status=' +
      status,
      this.httpOptionsForExportToExcel
    );
  }

  getDaywiseConveyanceDetailReport(closingDateId, userId, month, year) {
    return this.http.get<any>(
      this.appApi.daywiseConveyanceDetailReportAPI +
      '/' +
      closingDateId +
      '/' +
      userId +
      '/' +
      month +
      '/' +
      year,
      this.httpOptions
    );
  }

  getDaywiseConveyanceReportExcel(closingDateId, userId, month, year) {
    return this.http.get<any>(
      this.appApi.daywiseConveyanceReportExportToExcelAPI +
      '/' +
      closingDateId +
      '/' +
      userId +
      '/' +
      month +
      '/' +
      year,
      this.httpOptionsForExportToExcel
    );
  }

  getUserByPrtner(partnerId, status) {
    return this.http.get<any>(
      this.appApi.userOfPartnerAPI +
      '?partnersId=' +
      partnerId +
      '&status=' +
      status,
      this.httpOptions
    );
  }


  getOverTimeReport(fromClosingDateId, toClosingDateId, userId) {
    return this.http.get<any>(
      this.appApi.overTimeReportsAPI +
      '?fromClosingId=' +
      fromClosingDateId +
      '&toClosingId=' +
      toClosingDateId +
      '&userId=' +
      userId,
      this.httpOptions
    );
  }

  getOverTimeReportExcel(fromClosingDateId, toClosingDateId, userId) {
    return this.http.get<any>(
      this.appApi.overTimeReportsExcelAPI +
      '?fromClosingId=' +
      fromClosingDateId +
      '&toClosingId=' +
      toClosingDateId +
      '&userId=' +
      userId,
      this.httpOptionsForExportToExcel
    );
  }

  getArticleAvailabilityReport(partnerId) {
    return this.http.get<any>(
      this.appApi.articleAvailabilityReportAPI +
      '?partnerId=' +
      partnerId,
      this.httpOptions
    );
  }

  getArticleAvailabilityReportExcel(partnerId) {
    return this.http.get(
      this.appApi.articleAvailabilityExportToExcelAPI + '?partnerId=' + partnerId,
      this.httpOptionsForExportToExcel
    );
  }

  getLatestCtcDetailsReport(branchId, partnerId) {
    return this.http.get<any>(
      this.appApi.latestCtcDetailsReportAPI +'/' + branchId + '/' + partnerId,
      this.httpOptions
    );
  }

  getLatestCtcDetailsReportExcel(branchId, partnerId) {
    return this.http.get(
      this.appApi.latestCtcDetailsReportExportToExcelAPI +'/' + branchId + '/' + partnerId,
      this.httpOptionsForExportToExcel
    );
  }

  getLatestReportingPartnersReport(branchId) {
     return this.http.get<any>(
      this.appApi.latestReportingPartnersReportAPI +'/' + branchId,
      this.httpOptions
    );
  }

  getLatestReportingPartnersReportExcel(branchId) {
    return this.http.get(
      this.appApi.latestReportingPartnersReportExportToExcelAPI +'/' + branchId,
      this.httpOptionsForExportToExcel
    );
  }

  getPartnersByBranch(branchId) {
    return this.http.get(
      this.appApi.partnerByBranchAPI + '?branchId=' + branchId,
      this.httpOptions
    );
  }

  getAllBudgetedPartner(fyId) {
    return this.http.get(
      this.appApi.getAllBudgetedPartnerAPI + '/' + fyId,
      this.httpOptions
    );
  }

  getAllClientByYear(fyId, partnerId) {
    return this.http.get(
      this.appApi.getClientsByYearAPI + '/' + fyId + '?partnerId=' + partnerId,
      this.httpOptions
    );
  }

  getAllClientByYearAndBudget(fyId) {
    return this.http.get(
      this.appApi.getClientsByYearAndBudgetAPI + '/' + fyId,
      this.httpOptions
    );
  }

  getAllClientByPartner(partnerId) {
    return this.http.get(
      this.appApi.getClientsByPartnerAPI + '/' + partnerId,
      this.httpOptions
    );
  }


  getAllAssignment(fyId, clientId, partnerId) {
    return this.http.get(
      this.appApi.getClientsAPI + '/assignment-by-partner/' + fyId + '?clientId=' + clientId + '&partnerId=' + partnerId,
      this.httpOptions
    );
  }

  getBudgetVSActualCostForFY(fyId, manDays) {
    return this.http.get(
      this.appApi.budgetVSActualCostForFYAPI + '/' + fyId + '?manDays=' + manDays + '&clients=&assignments=',
      this.httpOptions
    );
  }

  getBudgetVSActualCostForPartner(fyId, partnerId, manDays) {
    return this.http.get(
      this.appApi.budgetVSActualCostForPartnerAPI + '/' + fyId + '?partnerId=' + partnerId + '&manDays=' + manDays,
      this.httpOptions
    );
  }


  getBudgetVSActualCostForFYByDesignation(fyId, clientId, assignmentId, partnerId, manDays) {
    return this.http.get(
      this.appApi.budgetVSActualCostForFYByDesignationAPI + '/' + fyId + '/' + partnerId + '?manDays=' + manDays + '&clients=' + clientId + '&assignments=' + assignmentId,
      this.httpOptions
    );
  }

  getBudgetVSActualCostForClient(fyId, clientId, partnerId, manDays) {
    return this.http.get(
      this.appApi.budgetVSActualCostForClientAPI + '/' + fyId + '/' + partnerId + '?manDays=' + manDays + '&clients=' + clientId,
      this.httpOptions
    );
  }

  getBudgetVSActualCostForAssignment(fyId, clientId, assignmentId, partnerId, manDays) {
    return this.http.get(
      this.appApi.budgetVSActualCostForAssignmentAPI + '/' + fyId + '/' + partnerId + '?manDays=' + manDays + '&clients=' + clientId + '&assignments=' + assignmentId,
      this.httpOptions
    );
  }

  getBankPaymentDetails(branchId, closingDateId) {
    return this.http.get(
      this.appApi.bankPaymentAPI + '/' + branchId + '/' + closingDateId,
      this.httpOptions
    );
  }

  getBankPaymentExportToExcel(branchId, closingDateId) {
    return this.http.get(
      this.appApi.bankPaymentExportToExcelAPI + '/' + branchId + '/' + closingDateId,
      this.httpOptionsForExportToExcel
    );
  }

  getClientExportToExcel() {
    return this.http.get(this.appApi.clientExportToExcelAPI, this.httpOptionsForExportToExcel);
  }

  getEmployeeByBranch(empStatusId, branchId) {
    return this.http.get(this.appApi.employeeByBranchAPI + '?profileStatus=' + empStatusId + '&branch=' + branchId, this.httpOptions);
  }

  getSalarySlipDetails(empId, fromClosingDateId, toClosingDateId) {
    return this.http.get(this.appApi.salarySlipReportAPI + '/' + empId + '/' + fromClosingDateId + '/' + toClosingDateId, this.httpOptions);
  }

  getSalarySlipExportToExcel(empId, fromClosingDateId, toClosingDateId) {
    return this.http.get(this.appApi.salarySlipReportExportToExcelAPI + '/' + empId + '/' + fromClosingDateId + '/' + toClosingDateId, this.httpOptionsForExportToExcel);
  }

  getArticleListByYearBranch(fyId, branchId) {
    return this.http.get(this.appApi.articleListByBranchAPI + '/' + fyId + '?branch=' + branchId,
      this.httpOptions
    );
  }

  getArticleListByBranch(branchId) {
    return this.http.get(this.appApi.articleListByBranchAPI + '?branch=' + branchId,
      this.httpOptions
    );
  }

  getDebitCreditHoursDetails(fyId, articleId) {
    return this.http.get(
      this.appApi.debitCreditHoursAPI + '/' + fyId + '?userId=' + articleId,
      this.httpOptions
    );
  }

  getDebitCreditHoursExportToExcel(fyId, articleId) {
    return this.http.get(
      this.appApi.debitCreditHoursExportToExcelAPI + '/' + fyId + '?userId=' + articleId,
      this.httpOptionsForExportToExcel
    );
  }

  getAnnualSalaryDetails(fyId, userId, partnerId, fromClosingDate, toClosingDate) {
    return this.http.get(
      this.appApi.annualSalaryReportAPI + '/' + fyId + '?userId=' + userId + '&partnerId=' + partnerId + '&fromClosingDate=' + fromClosingDate + '&toClosingDate=' + toClosingDate,
      this.httpOptions
    );
  }

  getAnnualSalaryReportExcel(fyId, userId, partnerId, fromClosingDate, toClosingDate) {
    return this.http.get(
      this.appApi.annualSalaryReportExcelAPI + '/' + fyId + '?userId=' + userId + '&partnerId=' + partnerId + '&fromClosingDate=' + fromClosingDate + '&toClosingDate=' + toClosingDate,
      this.httpOptionsForExportToExcel
    );
  }

  saveExitFormDetails(data) {
    return this.http.post<ExitFormModel>(
      this.appApi.saveExitFormAPI,
      data,
      this.httpOptions
    );
  }

  getExitFormSummaryDetails() {
    return this.http.get<ExitFormModel>(
      this.appApi.exitFormSummaryAPI,
      this.httpOptions
    );
  }

  getUserExitFormDetail() {
    return this.http.get<ExitFormModel>(
      this.appApi.userExitFormAPI,
      this.httpOptions
    );
  }

  updateExitFormDetails(data, userId, partnerId) {
    return this.http.put<ExitFormModel>(
      this.appApi.userExitFormAPI + '/' + userId + '/' + partnerId,
      data,
      this.httpOptions
    );
  }

  getAnnualStipendReportDetails(fyId, userId, partnerId) {
    return this.http.get(
      this.appApi.annualStipendReportAPI + '/' + fyId + '?userId=' + userId + '&partnerId=' + partnerId,
      this.httpOptions
    );
  }

  getAnnualStipendReportExcel(fyId, userId, partnerId) {
    return this.http.get(
      this.appApi.annualStipendReportExcelAPI + '/' + fyId + '?userId=' + userId + '&partnerId=' + partnerId,
      this.httpOptionsForExportToExcel
    );
  }

  getMyActualTaskDetails(userId, fyId, clientId, assignmentId) {
    return this.http.get(
      this.appApi.myActualTaskReportAPI + '/' + userId + '/' + fyId + '?clients=' + clientId + '&assignments=' + assignmentId,
      this.httpOptions
    );
  }

  getMyActualTaskExcel(userId, fyId, clientId, assignmentId) {
    return this.http.get(
      this.appApi.myActualTaskExcelAPI + '/' + userId + '/' + fyId + '?clients=' + clientId + '&assignments=' + assignmentId,
      this.httpOptionsForExportToExcel
    );
  }

  getUpdateBudgetReportDetails(fyId, partnerId, formData) {
    return this.http.put<BudgetReportModel>(this.appApi.updateBudgetExcelAPI + '/' + fyId + '/' + partnerId, formData, this.httpOptionsForUpload);
  }

  getVarianceReportExcelByPartner(fyId, partnerId) {
    return this.http.get(
      this.appApi.varianceReportExcelByPartnerAPI + '/' + fyId + '/' + partnerId,
      this.httpOptionsForExportToExcel
    );
  }

  getVarianceSummaryReport(fyId) {
    return this.http.get(
      this.appApi.varianceSummaryReportAPI + '/' + fyId,
      this.httpOptions
    );
  }

  getVarianceSummaryReportByMandaysFirmLevel(fyId) {
    return this.http.get(
      this.appApi.varianceSummaryReportByMandaysFirmLevelAPI + '/' + fyId,
      this.httpOptions
    );
  }

  getVarianceSummaryReportByMandaysPartnerLevel(partnerId, fyId,) {
    return this.http.get(
      this.appApi.varianceSummaryReportByMandaysPartnerLevelAPI + '/' + partnerId + '/' + fyId,
      this.httpOptions
    );
  }

  getPartnerVarianceSummaryReport(fyId, partnerId) {
    return this.http.get(
      this.appApi.partnerVarianceSummaryReportAPI + '/' + fyId + '/' + partnerId,
      this.httpOptions
    );
  }

  getVarianceReportExcelByYear(fyId) {
    return this.http.get(
      this.appApi.varianceReportExcelByYearAPI + '/' + fyId,
      this.httpOptionsForExportToExcel
    );
  }

  // ---------------------------Variance Summary Report Mandays ----------------------------


  getVarianceSummaryMandaysExcelByFirmLevel(fyId) {
    return this.http.get(
      this.appApi.varianceSummaryReportMandaysExcelByFirmLevel + '/' + fyId,
      this.httpOptionsForExportToExcel
    );
  }


  getVarianceSummaryMandaysExcelByPartnerLevel(fyId, partnerId) {
    return this.http.get(
      this.appApi.varianceSummaryReportMandaysExcelByPartnerLevel + '/' + fyId + '/' + partnerId,
      this.httpOptionsForExportToExcel
    );
  }


  // ------------------------------------------------------------------------------------------------


  getEmpanelmentRoleReportExcel(branchId, empanelmentRoleId, currentDate, serviceVerticalId) {
    return this.http.get(
      this.appApi.empanelmentReportExcelAPI +
      '?branchId=' +
      branchId +
      '&serviceVertical=' +
      serviceVerticalId +
      '&role=' +
      empanelmentRoleId +
      '&currDate=' +
      currentDate,
      this.httpOptionsForExportToExcel
    );
  }

  checkDiaryExistForBudget(clientId, assignmentId, fromDate, toDate) {
    return this.http.get(
      this.appApi.checkDiaryExistForBudgetAPI + '/' + clientId + '/' + fromDate + '/' + toDate + '?assignmentId=' + assignmentId,
      this.httpOptions
    );
  }

  getClientListByBranchStatus(branchId, status) {
    return this.http.get<any>(
      this.appApi.clientListByBranchStatus +
      '?branchId=' +
      branchId +
      '&status=' +
      status,
      this.httpOptions
    );
  }

  getUserDetails() {
    return this.http.get<any>(
      this.appApi.getUsersAPI,
      this.httpOptions
    );
  }

  getProfilePhotoForColleaugeDetails(userId) {
    return this.http.get(
      this.appApi.profileAPI + '/photo/' + userId,
      this.httpOptions
    );
  }

  getHolidaysReportDetails(branchId, yearId) {
    return this.http.get(
      this.appApi.myHolidayReportAPI + '/' + branchId + '/' + yearId,
      this.httpOptions
    );
  }

  getCommonDashboardDetails() {
    return this.http.get(
      this.appApi.commonDashboardCountAPI,
      this.httpOptions
    );
  }

  getHRAdminDashboardDetails() {
    return this.http.get(this.appApi.hrAdminDashboardCountAPI, this.httpOptions)
  }

  getPartnerDashboardDetails() {
    return this.http.get(this.appApi.partnerDashboardCountAPI, this.httpOptions);
  }

  getManagingPartnerDashboardDetails() {
    return this.http.get(this.appApi.managingPartnerDashboardAPI, this.httpOptions);
  }


  getMyTargetReportDetails(userId, fyId, clients) {
    return this.http.get(this.appApi.myTargetReportAPI + '/' + userId + '/' + fyId + '?clients=' + clients, this.httpOptions)
  }
  
  // getMonthlyNewJoineeReport(yearId, branchId,monthName) {
  //   return this.http.get(
  //     this.appApi.monthlyNewJoineeReportAPI + '/' + yearId + '/' + branchId + '?month='+ monthName,
  //     this.httpOptions
  //   );
  // }

  getMonthlyNewJoineeReport(yearId, branchId,fromMonthName,toMonthName) {
    return this.http.get(
      this.appApi.monthlyNewJoineeReportAPI + '/' + yearId + '/' + branchId + '?fromMonth=' + fromMonthName + '&toMonth=' + toMonthName,
      this.httpOptions
    );
  }
    
  // getMonthlyLeftEmployeeReport(yearId, branchId,monthName) {
  //   return this.http.get(
  //     this.appApi.monthlyLeftEmployeeReportAPI + '/' + yearId + '/' + branchId + '?month='+ monthName,
  //     this.httpOptions
  //   );
  // }
  getMonthlyLeftEmployeeReport(yearId, branchId,fromMonthName,toMonthName) {
    return this.http.get(
      this.appApi.monthlyLeftEmployeeReportAPI + '/' + yearId + '/' + branchId + '?fromMonth=' + fromMonthName + '&toMonth=' + toMonthName,
      this.httpOptions
    );
  }

  // getMonthlyNewJoineeReportExcel(fyId,branchId,monthName) {
  //   return this.http.get(
  //     this.appApi.monthlyNewJoineeExcelAPI + '/' + fyId + '/' + branchId + '?month='+ monthName,
  //     this.httpOptionsForExportToExcel
  //   );
  // }

   getMonthlyNewJoineeReportExcel(fyId,branchId,fromMonthName,toMonthName) {
    return this.http.get(
      this.appApi.monthlyNewJoineeExcelAPI + '/' + fyId + '/' + branchId + '?fromMonth=' + fromMonthName + '&toMonth=' + toMonthName,
      this.httpOptionsForExportToExcel
    );
  }

  // getMonthlyLeftEmployeeReportExcel(fyId,branchId,monthName) {
  //   return this.http.get(
  //     this.appApi.monthlyLeftEmployeeExcelAPI + '/' + fyId + '/' + branchId + '?month='+ monthName,
  //     this.httpOptionsForExportToExcel
  //   );
  // }
  getMonthlyLeftEmployeeReportExcel(fyId,branchId,fromMonthName,toMonthName) {
    return this.http.get(
      this.appApi.monthlyLeftEmployeeExcelAPI + '/' + fyId + '/' + branchId + '?fromMonth=' + fromMonthName + '&toMonth=' + toMonthName,
      this.httpOptionsForExportToExcel
    );
  }

  getProbationCompleteDetails(month, year) {
    return this.http.get(
      this.appApi.probationCompleteDetailsAPI + '/' + month + '/' + year,
      this.httpOptions
    );
  }

  getArticleshipEndDetails(month, year) {
    return this.http.get(
      this.appApi.articleshipEndAPI + '/' + month + '/' + year,
      this.httpOptions
    );
  }

  getConsultantsEndDetails(month, year) {
    return this.http.get(
      this.appApi.consultantsEndAPI + '/' + month + '/' + year,
      this.httpOptions
    );
  }


  getWorkAnniversaryReport(month, year) {
    return this.http.get(
      this.appApi.workAnniversaryReportAPI + '/' + month + '/' + year,
      this.httpOptions
    );
  }

  getIncompleteProfilesReport() {
    return this.http.get(
      this.appApi.incompleteProfilesReportAPI,
      this.httpOptions
    );
  }

  getIncompleteProfilesReportExcel() {
    return this.http.get(
      this.appApi.incompleteProfilesReportExportToExcelAPI,
      this.httpOptionsForExportToExcel
    );
  }

  getAssetDetailsByBranchStatusExcel(branchId, status) {
    return this.http.get(
      this.appApi.assetsByBranchStatusExcelAPI + '/' + branchId + '/' + status,
      this.httpOptionsForExportToExcel
    );
  }
}


@Injectable({
  providedIn: 'root',
})
export class DocumentListService {
  private documentSubject = new Subject<DocumentModel>();
  sendDocument(document: DocumentModel) {
    this.documentSubject.next(document);
  }

  getDocument(): Observable<any> {
    return this.documentSubject.asObservable();
  }

  clearDocument() {
    this.documentSubject.next();
  }

  private deleteFolderId = new Subject<DocumentModel>()
  sendFolderIdForDelete(folderId) {
    this.deleteFolderId.next(folderId);
  }

  getFolderIdForDelete(): Observable<any> {
    return this.deleteFolderId.asObservable();
  }

  clearDeleteFolder() {
    this.deleteFolderId.next();
  }

  private folderUpdateData = new Subject<DocumentModel>();
  sendUpdatedFolder(folderData: DocumentModel) {
    this.folderUpdateData.next(folderData);
  }

  getUpdatedFolder(): Observable<any> {
    return this.folderUpdateData.asObservable();
  }

  clearUpdatedFolder() {
    this.folderUpdateData.next();
  }
}

function getProbationCompleteDetails(month: any, year: any) {
  throw new Error('Function not implemented.');
}

